// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import { useTranslation } from 'react-i18next';
import Logo from '../assets/logos/upcircle_logo_circle.png';

const LoadingScreen = () => {
  const { t } = useTranslation();
  return (
    <div className='loading-screen'>
      <div className='spinning-logo-container'>
        <img src={Logo} className='spinning-logo' />
      </div>
      <p>{t('general_loading')}...</p>
    </div>
  );
};

export default LoadingScreen;
